// MX Fabric Inventory Status
// Auto-generated from user inventory list
// Total entries: 1940 (includes 207 YUBOYUAN fabrics)

export const MX_INVENTORY = {
  "A52024006": "in_stock",
  "A52024012": "in_stock",
  "A52024016": "in_stock",
  "A52024018": "in_stock",
  "A52024020": "in_stock",
  "A52024024": "in_stock",
  "A52024025": "in_stock",
  "A52024027": "in_stock",
  "A52024028": "in_stock",
  "A52024029": "in_stock",
  "A52024044": "in_stock",
  "A52024045": "in_stock",
  "A52024051": "in_stock",
  "A52024052": "in_stock",
  "A52024053": "in_stock",
  "A52024060": "in_stock",
  "A52024062": "in_stock",
  "A52024064": "in_stock",
  "A52024065": "in_stock",
  "A52024075": "in_stock",
  "A52024076": "in_stock",
  "A52024083": "in_stock",
  "A52024116": "in_stock",
  "A52024117": "need_purchase",
  "B52024001": "in_stock",
  "B52024002": "in_stock",
  "B52024003": "in_stock",
  "B52024008": "in_stock",
  "B52024010": "in_stock",
  "B52024021": "in_stock",
  "B52024022": "in_stock",
  "B52024023": "in_stock",
  "B52024034": "in_stock",
  "B52024035": "in_stock",
  "B52024036": "in_stock",
  "B52024037": "in_stock",
  "B52024040": "in_stock",
  "B52024041": "in_stock",
  "B52024046": "in_stock",
  "B52024047": "in_stock",
  "B52024048": "in_stock",
  "B52024049": "in_stock",
  "B52024050": "in_stock",
  "B52024054": "in_stock",
  "B52024055": "in_stock",
  "B52024056": "in_stock",
  "B52024057": "in_stock",
  "B52024058": "in_stock",
  "B52024059": "in_stock",
  "B52024061": "in_stock",
  "B52024066": "in_stock",
  "B52024080": "in_stock",
  "B52024081": "in_stock",
  "B52024082": "in_stock",
  "B52024091": "in_stock",
  "B52024092": "in_stock",
  "B52024093": "in_stock",
  "B52024094": "in_stock",
  "B52024096": "in_stock",
  "B52024097": "in_stock",
  "B52024098": "in_stock",
  "B52024101": "in_stock",
  "B52024102": "in_stock",
  "B52024103": "in_stock",
  "B52024107": "in_stock",
  "B52024108": "in_stock",
  "B52024109": "in_stock",
  "C52024004": "in_stock",
  "C52024005": "in_stock",
  "C52024007": "in_stock",
  "C52024009": "in_stock",
  "C52024011": "in_stock",
  "C52024013": "in_stock",
  "C52024014": "in_stock",
  "C52024015": "in_stock",
  "C52024017": "in_stock",
  "C52024019": "in_stock",
  "C52024026": "in_stock",
  "C52024033": "in_stock",
  "C52024038": "in_stock",
  "C52024042": "in_stock",
  "C52024043": "in_stock",
  "C52024067": "in_stock",
  "C52024068": "in_stock",
  "C52024069": "in_stock",
  "C52024070": "in_stock",
  "C52024071": "in_stock",
  "C52024072": "in_stock",
  "C52024073": "in_stock",
  "C52024074": "in_stock",
  "C52024077": "in_stock",
  "C52024078": "in_stock",
  "C52024079": "in_stock",
  "C52024084": "in_stock",
  "C52024085": "in_stock",
  "C52024086": "in_stock",
  "C52024087": "in_stock",
  "C52024088": "in_stock",
  "C52024089": "in_stock",
  "C52024090": "in_stock",
  "C52024095": "in_stock",
  "C52024099": "in_stock",
  "C52024100": "in_stock",
  "C52024104": "in_stock",
  "C52024105": "in_stock",
  "C52024106": "in_stock",
  "C52024110": "in_stock",
  "C52024111": "in_stock",
  "C52024112": "in_stock",
  "C52024113": "in_stock",
  "C52024114": "in_stock",
  "C52024115": "in_stock",
  "C60101": "in_stock",
  "C60102": "in_stock",
  "C60103": "in_stock",
  "C60104": "in_stock",
  "C60105": "in_stock",
  "C60106": "in_stock",
  "C60107": "in_stock",
  "C60108": "in_stock",
  "C60109": "in_stock",
  "C60110": "in_stock",
  "C60111": "in_stock",
  "C60112": "in_stock",
  "C60113": "in_stock",
  "C60114": "in_stock",
  "C60115": "in_stock",
  "C60116": "in_stock",
  "C60117": "in_stock",
  "C60118": "in_stock",
  "C60119": "in_stock",
  "C60120": "in_stock",
  "C60121": "in_stock",
  "C60122": "in_stock",
  "C60123": "in_stock",
  "C60124": "in_stock",
  "C60125": "in_stock",
  "C60126": "in_stock",
  "C60127": "in_stock",
  "C60128": "in_stock",
  "C60129": "in_stock",
  "C60130": "in_stock",
  "C60131": "in_stock",
  "C60132": "in_stock",
  "C60133": "in_stock",
  "C60134": "in_stock",
  "C60135": "in_stock",
  "C60136": "in_stock",
  "C60137": "in_stock",
  "C60138": "in_stock",
  "C60139": "in_stock",
  "C60140": "in_stock",
  "C60141": "in_stock",
  "C60142": "in_stock",
  "C60143": "need_purchase",
  "C60144": "need_purchase",
  "C60145": "need_purchase",
  "C60146": "need_purchase",
  "C60147": "need_purchase",
  "C60148": "need_purchase",
  "C60149": "need_purchase",
  "D50424501": "need_purchase",
  "D50424502": "need_purchase",
  "D50424503": "need_purchase",
  "D50424504": "need_purchase",
  "D50424505": "need_purchase",
  "D50424506": "need_purchase",
  "D50424507": "need_purchase",
  "D50424508": "need_purchase",
  "D50424509": "need_purchase",
  "D50424510": "need_purchase",
  "D50424511": "need_purchase",
  "D50424512": "need_purchase",
  "D50424513": "need_purchase",
  "D50424514": "need_purchase",
  "D50424515": "need_purchase",
  "D50424516": "need_purchase",
  "D50424517": "need_purchase",
  "D50424518": "need_purchase",
  "D50424519": "need_purchase",
  "D50424520": "need_purchase",
  "D50424521": "need_purchase",
  "D50424522": "need_purchase",
  "D50424523": "need_purchase",
  "D50424524": "need_purchase",
  "D50424525": "need_purchase",
  "D50424526": "need_purchase",
  "D50424527": "need_purchase",
  "D50424528": "need_purchase",
  "D50424529": "need_purchase",
  "D50424530": "need_purchase",
  "D50424531": "need_purchase",
  "D50424532": "need_purchase",
  "D50424533": "need_purchase",
  "D50424534": "need_purchase",
  "D50424535": "need_purchase",
  "D50424536": "need_purchase",
  "D50424537": "need_purchase",
  "D50424538": "need_purchase",
  "D50424539": "in_stock",
  "E10424201": "need_purchase",
  "E10424202": "need_purchase",
  "E10424203": "need_purchase",
  "E10424204": "need_purchase",
  "E10424205": "need_purchase",
  "E10424206": "need_purchase",
  "E10424207": "need_purchase",
  "E10424208": "need_purchase",
  "E10424209": "need_purchase",
  "E10424210": "need_purchase",
  "E10424211": "need_purchase",
  "E10424212": "need_purchase",
  "E10424213": "need_purchase",
  "E10424214": "need_purchase",
  "E10424215": "need_purchase",
  "E10424216": "need_purchase",
  "E10424217": "need_purchase",
  "E10424218": "need_purchase",
  "E10424219": "need_purchase",
  "E10424220": "need_purchase",
  "E10424221": "need_purchase",
  "E10424222": "need_purchase",
  "E10424223": "need_purchase",
  "E10424224": "need_purchase",
  "E10424225": "need_purchase",
  "E10424226": "need_purchase",
  "E10424227": "need_purchase",
  "E10424228": "need_purchase",
  "E10424229": "need_purchase",
  "E10424230": "need_purchase",
  "E10424231": "need_purchase",
  "E10424232": "need_purchase",
  "E10424233": "need_purchase",
  "E10424234": "need_purchase",
  "E10424235": "need_purchase",
  "E10424236": "need_purchase",
  "E10424237": "need_purchase",
  "E10424238": "need_purchase",
  "E10424239": "need_purchase",
  "E10424240": "need_purchase",
  "E10424241": "need_purchase",
  "E10424242": "need_purchase",
  "E10424243": "need_purchase",
  "E10424244": "need_purchase",
  "E10424245": "need_purchase",
  "E10424246": "need_purchase",
  "E10424247": "need_purchase",
  "E10424248": "need_purchase",
  "E10424249": "need_purchase",
  "E10424250": "need_purchase",
  "E10424251": "need_purchase",
  "E10424252": "in_stock",
  "J39101/200": "in_stock",
  "J39102/200": "in_stock",
  "J39103/200": "in_stock",
  "J39104/200": "in_stock",
  "J39105/200": "in_stock",
  "J39106/200": "in_stock",
  "J39107/200": "in_stock",
  "J39108/200": "in_stock",
  "J39109/200": "in_stock",
  "J39110/200": "in_stock",
  "J39111/200": "in_stock",
  "J39112/200": "in_stock",
  "J39113/200": "in_stock",
  "J39114/200": "in_stock",
  "J39115/200": "in_stock",
  "J39116/200": "in_stock",
  "J39117/220": "in_stock",
  "J39118/220": "in_stock",
  "J39119/200": "in_stock",
  "J39120/200": "in_stock",
  "J39121/200": "in_stock",
  "J39122/200": "in_stock",
  "J39123/200": "in_stock",
  "J39124/200": "in_stock",
  "J39125/200": "in_stock",
  "J39126/200": "in_stock",
  "J39127/200": "in_stock",
  "J39128/200": "in_stock",
  "J39129/200": "in_stock",
  "J39130/200": "in_stock",
  "J39131/220": "in_stock",
  "J39132/200": "in_stock",
  "J39133/200": "in_stock",
  "J39134/200": "in_stock",
  "J39135/200": "in_stock",
  "J39136/200": "in_stock",
  "J39137/200": "in_stock",
  "J39138/200": "in_stock",
  "J39139/200": "in_stock",
  "J39140/200": "in_stock",
  "J39141/200": "in_stock",
  "J39142/200": "in_stock",
  "J39143/200": "in_stock",
  "J39144/200": "in_stock",
  "J39145/220": "in_stock",
  "J39146/220": "in_stock",
  "J39147/220": "in_stock",
  "J39148/200": "in_stock",
  "J39149/220": "in_stock",
  "J39150/220": "in_stock",
  "J39151/220": "in_stock",
  "J39152/200": "in_stock",
  "J39153/200": "in_stock",
  "J39154/220": "in_stock",
  "J39155/220": "in_stock",
  "J39156/200": "in_stock",
  "J39157/220": "in_stock",
  "J39158/220": "in_stock",
  "J39159/200": "in_stock",
  "J39160/200": "in_stock",
  "J39161/220": "in_stock",
  "J39162/200": "in_stock",
  "J39163/200": "in_stock",
  "J39164/200": "in_stock",
  "J39165/200": "in_stock",
  "J39166/220": "in_stock",
  "J39167/200": "in_stock",
  "J39168/200": "in_stock",
  "J39169/220": "in_stock",
  "J39170/220": "in_stock",
  "J39171/220": "in_stock",
  "J39172/200": "in_stock",
  "J39173/200": "in_stock",
  "J39174/200": "in_stock",
  "J39175/220": "in_stock",
  "J39176/220": "in_stock",
  "J39177/200": "in_stock",
  "J39178/220": "in_stock",
  "J39179/220": "in_stock",
  "J39180/220": "in_stock",
  "J39181/220": "in_stock",
  "J39182/220": "in_stock",
  "J39183/220": "in_stock",
  "J39184/220": "in_stock",
  "J39185/220": "in_stock",
  "J39186/220": "in_stock",
  "J39187/220": "in_stock",
  "J39188/220": "in_stock",
  "J39189/220": "in_stock",
  "J39190/220": "in_stock",
  "J39191/220": "in_stock",
  "J39192/220": "in_stock",
  "J39193/220": "in_stock",
  "J39194/220": "in_stock",
  "J39195/220": "need_purchase",
  "J39196/220": "in_stock",
  "J39197/220": "need_purchase",
  "J39198/220": "need_purchase",
  "J39199/220": "need_purchase",
  "J39200/220": "in_stock",
  "J39201/220": "in_stock",
  "J39202/220": "need_purchase",
  "J39203/220": "need_purchase",
  "J39204/220": "need_purchase",
  "J39205/220": "need_purchase",
  "J39206/220": "need_purchase",
  "J39207/220": "in_stock",
  "J39208/220": "in_stock",
  "J39209/220": "need_purchase",
  "J39210/220": "need_purchase",
  "J39211/220": "need_purchase",
  "J39212/220": "in_stock",
  "J39213/220": "in_stock",
  "J39214/220": "in_stock",
  "J39215/220": "need_purchase",
  "J39216/220": "need_purchase",
  "J39217/220": "in_stock",
  "J39218/220": "in_stock",
  "J39219/220": "in_stock",
  "J39220/220": "in_stock",
  "J39221/220": "in_stock",
  "J39222/220": "need_purchase",
  "J39223/220": "need_purchase",
  "J39224/220": "in_stock",
  "J39225/220": "in_stock",
  "J39226/220": "in_stock",
  "J39227/220": "in_stock",
  "J39228/220": "in_stock",
  "J39229/220": "in_stock",
  "J39230/220": "in_stock",
  "J39231/220": "in_stock",
  "J39232/220": "in_stock",
  "J39233/220": "in_stock",
  "J39234/220": "in_stock",
  "J39235/220": "in_stock",
  "J39236/220": "in_stock",
  "J39237/220": "in_stock",
  "J39238/220": "in_stock",
  "J39239/220": "in_stock",
  "J39240/220": "in_stock",
  "L51701": "need_purchase",
  "L51702": "need_purchase",
  "L51703": "need_purchase",
  "L51704": "need_purchase",
  "L51705": "need_purchase",
  "L51706": "need_purchase",
  "L51707": "need_purchase",
  "L51708": "need_purchase",
  "L51709": "need_purchase",
  "L51710": "need_purchase",
  "L51711": "need_purchase",
  "L51712": "need_purchase",
  "L51713": "need_purchase",
  "L51714": "need_purchase",
  "L51715": "need_purchase",
  "L51716": "need_purchase",
  "L51717": "need_purchase",
  "L51718": "need_purchase",
  "L51719": "need_purchase",
  "L51720": "need_purchase",
  "L51721": "need_purchase",
  "L51722": "need_purchase",
  "L51723": "need_purchase",
  "L51724": "need_purchase",
  "L51725": "need_purchase",
  "L51726": "need_purchase",
  "L51727": "need_purchase",
  "L51728": "need_purchase",
  "L51729": "need_purchase",
  "L51730": "need_purchase",
  "L51731": "need_purchase",
  "L51732": "need_purchase",
  "L51733": "need_purchase",
  "L51734": "need_purchase",
  "L51735": "need_purchase",
  "L51736": "need_purchase",
  "L51737": "need_purchase",
  "L51738": "need_purchase",
  "L51739": "need_purchase",
  "L51740": "need_purchase",
  "L51741": "need_purchase",
  "L51742": "need_purchase",
  "L51743": "need_purchase",
  "L51744": "need_purchase",
  "L51745": "need_purchase",
  "L51746": "need_purchase",
  "L51747": "need_purchase",
  "L51748": "need_purchase",
  "L51749": "need_purchase",
  "L51750": "need_purchase",
  "L51751": "need_purchase",
  "L51752": "need_purchase",
  "L51753": "need_purchase",
  "L51754": "need_purchase",
  "L51755": "need_purchase",
  "L51756": "need_purchase",
  "L51757": "need_purchase",
  "L51758": "need_purchase",
  "L51759": "need_purchase",
  "L51760": "in_stock",
  "L51810": "need_purchase",
  "L51811": "need_purchase",
  "L51812": "need_purchase",
  "L51813": "need_purchase",
  "L51814": "need_purchase",
  "L51815": "need_purchase",
  "L51816": "need_purchase",
  "L51817": "need_purchase",
  "L51818": "need_purchase",
  "L51819": "need_purchase",
  "L51820": "need_purchase",
  "L51821": "need_purchase",
  "L51822": "need_purchase",
  "L51823": "need_purchase",
  "L51824": "need_purchase",
  "L51825": "need_purchase",
  "L51826": "need_purchase",
  "L51827": "need_purchase",
  "L51828": "need_purchase",
  "L51829": "need_purchase",
  "L51830": "need_purchase",
  "L51831": "need_purchase",
  "L51832": "need_purchase",
  "L51833": "need_purchase",
  "L51834": "need_purchase",
  "L51835": "need_purchase",
  "L51836": "need_purchase",
  "L51837": "need_purchase",
  "L51838": "need_purchase",
  "L51839": "need_purchase",
  "L51840": "need_purchase",
  "L51841": "need_purchase",
  "L51842": "need_purchase",
  "L51845": "need_purchase",
  "L51846": "need_purchase",
  "L51847": "need_purchase",
  "L51848": "need_purchase",
  "L51849": "need_purchase",
  "L51850": "need_purchase",
  "L51851": "need_purchase",
  "L51852": "need_purchase",
  "L51853": "need_purchase",
  "L51854": "need_purchase",
  "L51855": "need_purchase",
  "L51856": "need_purchase",
  "L51857": "need_purchase",
  "L51858": "need_purchase",
  "L51859": "need_purchase",
  "L51860": "need_purchase",
  "L51861": "need_purchase",
  "L51862": "need_purchase",
  "L51863": "need_purchase",
  "L51864": "need_purchase",
  "L51865": "need_purchase",
  "L51866": "need_purchase",
  "L51867": "need_purchase",
  "L51868": "need_purchase",
  "L51869": "need_purchase",
  "L51870": "need_purchase",
  "L51871": "need_purchase",
  "L51872": "need_purchase",
  "L51873": "need_purchase",
  "L51874": "need_purchase",
  "L51875": "need_purchase",
  "L51876": "need_purchase",
  "L51877": "need_purchase",
  "L51878": "need_purchase",
  "L51879": "need_purchase",
  "L51886": "need_purchase",
  "L51887": "need_purchase",
  "L51888": "need_purchase",
  "L51889": "in_stock",
  "L51901": "need_purchase",
  "L51902": "need_purchase",
  "L51903": "need_purchase",
  "L51904": "need_purchase",
  "L51905": "need_purchase",
  "L51906": "need_purchase",
  "L51907": "need_purchase",
  "L51908": "need_purchase",
  "L51909": "need_purchase",
  "L51910": "need_purchase",
  "L51911": "need_purchase",
  "L51912": "need_purchase",
  "L51913": "need_purchase",
  "L51914": "need_purchase",
  "L51915": "need_purchase",
  "L51916": "need_purchase",
  "L51917": "need_purchase",
  "L51918": "need_purchase",
  "L51919": "need_purchase",
  "L51920": "need_purchase",
  "L51921": "need_purchase",
  "L51922": "need_purchase",
  "L51923": "need_purchase",
  "L51924": "need_purchase",
  "L51925": "need_purchase",
  "L51926": "need_purchase",
  "L51927": "need_purchase",
  "L51928": "need_purchase",
  "L51929": "need_purchase",
  "L51930": "need_purchase",
  "L51931": "need_purchase",
  "L51932": "need_purchase",
  "L51933": "need_purchase",
  "L51934": "need_purchase",
  "L51935": "need_purchase",
  "L51936": "need_purchase",
  "L51937": "need_purchase",
  "L51938": "need_purchase",
  "L51939": "need_purchase",
  "L51940": "need_purchase",
  "L51941": "need_purchase",
  "L51942": "need_purchase",
  "L51943": "need_purchase",
  "L51944": "need_purchase",
  "L51945": "need_purchase",
  "L51946": "need_purchase",
  "L51947": "need_purchase",
  "L51948": "need_purchase",
  "L51949": "need_purchase",
  "L51950": "need_purchase",
  "L51951": "need_purchase",
  "L51952": "need_purchase",
  "L51953": "need_purchase",
  "L51954": "need_purchase",
  "L51955": "in_stock",
  "M51001": "need_purchase",
  "M51002": "need_purchase",
  "M51003": "need_purchase",
  "M51004": "need_purchase",
  "M51005": "need_purchase",
  "M51006": "need_purchase",
  "M51007": "need_purchase",
  "M51008": "need_purchase",
  "M51009": "need_purchase",
  "M51010": "need_purchase",
  "M51011": "need_purchase",
  "M51012": "need_purchase",
  "M51013": "need_purchase",
  "M51014": "need_purchase",
  "M51015": "need_purchase",
  "M51016": "need_purchase",
  "M51017": "need_purchase",
  "M51018": "need_purchase",
  "M51019": "need_purchase",
  "M51020": "need_purchase",
  "M51021": "need_purchase",
  "M51022": "need_purchase",
  "M51023": "need_purchase",
  "M51024": "need_purchase",
  "M51025": "need_purchase",
  "M51026": "need_purchase",
  "M51027": "need_purchase",
  "M51028": "need_purchase",
  "M51029": "need_purchase",
  "M51030": "need_purchase",
  "M51031": "need_purchase",
  "M51032": "need_purchase",
  "M51033": "need_purchase",
  "M51034": "need_purchase",
  "M51035": "need_purchase",
  "M51036": "need_purchase",
  "M51037": "need_purchase",
  "M51038": "need_purchase",
  "M51039": "need_purchase",
  "M51040": "need_purchase",
  "M51041": "need_purchase",
  "M51042": "need_purchase",
  "M51043": "need_purchase",
  "M51044": "need_purchase",
  "M51045": "need_purchase",
  "M51046": "need_purchase",
  "M51047": "need_purchase",
  "M51048": "need_purchase",
  "M51049": "need_purchase",
  "M51050": "need_purchase",
  "M51051": "need_purchase",
  "M51052": "need_purchase",
  "M51053": "need_purchase",
  "M51054": "need_purchase",
  "M51055": "need_purchase",
  "M51056": "need_purchase",
  "M51057": "need_purchase",
  "M51058": "need_purchase",
  "M51059": "need_purchase",
  "M51060": "need_purchase",
  "M51061": "in_stock",
  "N52101": "need_purchase",
  "N52102": "need_purchase",
  "N52103": "need_purchase",
  "N52104": "need_purchase",
  "N52105": "need_purchase",
  "N52106": "need_purchase",
  "N52107": "need_purchase",
  "N52108": "need_purchase",
  "N52109": "need_purchase",
  "N52110": "need_purchase",
  "N52111": "need_purchase",
  "N52112": "need_purchase",
  "N52113": "need_purchase",
  "N52114": "need_purchase",
  "N52115": "need_purchase",
  "N52116": "need_purchase",
  "N52117": "need_purchase",
  "N52118": "need_purchase",
  "N52119": "need_purchase",
  "N52120": "need_purchase",
  "N52121": "need_purchase",
  "N52122": "need_purchase",
  "N52123": "need_purchase",
  "N52124": "need_purchase",
  "N52125": "need_purchase",
  "N52126": "need_purchase",
  "N52127": "need_purchase",
  "N52128": "need_purchase",
  "N52129": "need_purchase",
  "N52130": "need_purchase",
  "NO.MX23041": "in_stock",
  "NO.MX23042": "in_stock",
  "NO.MX23043": "in_stock",
  "NO.MX23044": "in_stock",
  "NO.MX23045": "in_stock",
  "NO.MX23046": "in_stock",
  "NO.MX23048": "need_purchase",
  "NO.MX23049": "need_purchase",
  "NO.MX23051": "need_purchase",
  "NO.MX23053": "need_purchase",
  "NO.MX23054": "need_purchase",
  "NO.MX23056": "in_stock",
  "NO.MX23057": "in_stock",
  "NO.MX23058": "in_stock",
  "P510901": "in_stock",
  "P510902": "in_stock",
  "P510903": "in_stock",
  "P510904": "in_stock",
  "P510905": "in_stock",
  "P510906": "in_stock",
  "P510907": "in_stock",
  "P510908": "in_stock",
  "P510909": "in_stock",
  "P510910": "in_stock",
  "P510911": "in_stock",
  "P510912": "in_stock",
  "P510913": "in_stock",
  "P510914": "in_stock",
  "P510915": "in_stock",
  "P510916": "need_purchase",
  "P510917": "need_purchase",
  "P510918": "need_purchase",
  "P510919": "need_purchase",
  "P510920": "need_purchase",
  "P510921": "need_purchase",
  "P510922": "need_purchase",
  "P510923": "need_purchase",
  "P510924": "in_stock",
  "P510925": "in_stock",
  "P510926": "in_stock",
  "P510927": "in_stock",
  "P510928": "in_stock",
  "P510929": "in_stock",
  "P510930": "in_stock",
  "P510931": "in_stock",
  "P510932": "in_stock",
  "P510933": "in_stock",
  "P510934": "in_stock",
  "P510935": "in_stock",
  "P510936": "in_stock",
  "P510937": "in_stock",
  "P510938": "in_stock",
  "P510939": "in_stock",
  "P510940": "in_stock",
  "P510941": "in_stock",
  "P510942": "in_stock",
  "P510943": "in_stock",
  "P51111": "need_purchase",
  "P51112": "in_stock",
  "P51113": "in_stock",
  "P51114": "in_stock",
  "P51115": "in_stock",
  "P51116": "in_stock",
  "P51117": "in_stock",
  "P51118": "in_stock",
  "P51119": "in_stock",
  "P51120": "need_purchase",
  "P51121": "in_stock",
  "P51122": "need_purchase",
  "P51123": "need_purchase",
  "P51124": "in_stock",
  "P51125": "need_purchase",
  "P51126": "need_purchase",
  "P51127": "in_stock",
  "P51128": "in_stock",
  "P51129": "need_purchase",
  "P51130": "need_purchase",
  "P51131": "in_stock",
  "P51132": "in_stock",
  "P51133": "in_stock",
  "P51134": "need_purchase",
  "P51135": "need_purchase",
  "P51136": "need_purchase",
  "P51137": "need_purchase",
  "P51138": "need_purchase",
  "P51139": "need_purchase",
  "P51140": "need_purchase",
  "P51141": "need_purchase",
  "P51142": "need_purchase",
  "P51143": "need_purchase",
  "P51144": "need_purchase",
  "P51145": "need_purchase",
  "P51146": "in_stock",
  "P53201": "in_stock",
  "P53202": "in_stock",
  "P53203": "in_stock",
  "P53204": "need_purchase",
  "P53205": "in_stock",
  "P53206": "in_stock",
  "P53207": "in_stock",
  "P53208": "in_stock",
  "P53209": "in_stock",
  "P53210": "in_stock",
  "P53211": "need_purchase",
  "P53212": "need_purchase",
  "P53213": "need_purchase",
  "P53214": "need_purchase",
  "P53215": "need_purchase",
  "P53216": "need_purchase",
  "P53217": "need_purchase",
  "P53218": "need_purchase",
  "P53219": "in_stock",
  "P53220": "need_purchase",
  "P53221": "in_stock",
  "P53222": "in_stock",
  "P53223": "need_purchase",
  "P53224": "need_purchase",
  "P53225": "need_purchase",
  "P53226": "need_purchase",
  "P53227": "need_purchase",
  "P53228": "need_purchase",
  "P53229": "need_purchase",
  "P53230": "need_purchase",
  "P53231": "in_stock",
  "P53232": "in_stock",
  "P53233": "need_purchase",
  "P53234": "in_stock",
  "P53235": "need_purchase",
  "P53236": "need_purchase",
  "P53237": "need_purchase",
  "P53238": "need_purchase",
  "P53239": "need_purchase",
  "P53240": "need_purchase",
  "P53241": "in_stock",
  "P53242": "need_purchase",
  "P53243": "in_stock",
  "P53244": "need_purchase",
  "P53245": "in_stock",
  "P55401": "in_stock",
  "P55402": "in_stock",
  "P55403": "in_stock",
  "P55404": "in_stock",
  "P55405": "in_stock",
  "P55406": "need_purchase",
  "P55407": "in_stock",
  "P55408": "in_stock",
  "P55409": "need_purchase",
  "P55410": "in_stock",
  "P55411": "in_stock",
  "P55412": "in_stock",
  "P55413": "in_stock",
  "P55414": "in_stock",
  "P55415": "in_stock",
  "P55416": "in_stock",
  "P55417": "in_stock",
  "P55418": "in_stock",
  "P55419": "in_stock",
  "P55420": "in_stock",
  "P55421": "in_stock",
  "P55422": "in_stock",
  "P55423": "in_stock",
  "P55424": "in_stock",
  "P55425": "need_purchase",
  "P55426": "in_stock",
  "P55427": "in_stock",
  "P55428": "in_stock",
  "P55429": "in_stock",
  "P55430": "in_stock",
  "P55431": "in_stock",
  "P55432": "in_stock",
  "P55433": "in_stock",
  "P55434": "in_stock",
  "P55435": "in_stock",
  "P55436": "in_stock",
  "P55437": "in_stock",
  "P55438": "in_stock",
  "P55439": "in_stock",
  "P55440": "in_stock",
  "P55441": "in_stock",
  "P55442": "in_stock",
  "P55443": "in_stock",
  "P56501": "in_stock",
  "P56502": "in_stock",
  "P56503": "need_purchase",
  "P56504": "need_purchase",
  "P56505": "need_purchase",
  "P56506": "need_purchase",
  "P56507": "need_purchase",
  "P56508": "need_purchase",
  "P56509": "need_purchase",
  "P56510": "need_purchase",
  "P56511": "need_purchase",
  "P56512": "need_purchase",
  "P56513": "in_stock",
  "P56514": "need_purchase",
  "P56515": "need_purchase",
  "P56516": "in_stock",
  "P56517": "need_purchase",
  "P56518": "need_purchase",
  "P56519": "need_purchase",
  "P56520": "need_purchase",
  "P56521": "need_purchase",
  "P56522": "need_purchase",
  "P56523": "need_purchase",
  "P56524": "need_purchase",
  "P56525": "need_purchase",
  "P56526": "need_purchase",
  "P56527": "need_purchase",
  "P56528": "in_stock",
  "P56529": "in_stock",
  "P56530": "need_purchase",
  "P56531": "need_purchase",
  "P56532": "in_stock",
  "P56533": "in_stock",
  "P56534": "in_stock",
  "P56535": "in_stock",
  "P56536": "in_stock",
  "P56537": "in_stock",
  "P56538": "in_stock",
  "P56539": "in_stock",
  "P56540": "in_stock",
  "P56541": "in_stock",
  "P56542": "in_stock",
  "P56543": "need_purchase",
  "P56544": "need_purchase",
  "P56545": "need_purchase",
  "P56546": "in_stock",
  "P56547": "in_stock",
  "P56548": "need_purchase",
  "P56549": "in_stock",
  "P56550": "in_stock",
  "P56551": "in_stock",
  "P56552": "in_stock",
  "P56553": "in_stock",
  "P56554": "in_stock",
  "P56555": "in_stock",
  "P56556": "in_stock",
  "P56557": "in_stock",
  "P57601": "in_stock",
  "P57602": "in_stock",
  "P57603": "in_stock",
  "P57604": "in_stock",
  "P57605": "need_purchase",
  "P57606": "need_purchase",
  "P57607": "need_purchase",
  "P57608": "in_stock",
  "P57609": "need_purchase",
  "P57610": "in_stock",
  "P57611": "in_stock",
  "P57612": "in_stock",
  "P57613": "in_stock",
  "P57614": "need_purchase",
  "P57615": "in_stock",
  "P57616": "in_stock",
  "P57617": "in_stock",
  "P57618": "in_stock",
  "P57619": "need_purchase",
  "P57620": "in_stock",
  "P57621": "need_purchase",
  "P57622": "need_purchase",
  "P57623": "need_purchase",
  "P57624": "need_purchase",
  "P57625": "need_purchase",
  "P57626": "need_purchase",
  "P57627": "in_stock",
  "P57628": "need_purchase",
  "P57629": "need_purchase",
  "P57630": "need_purchase",
  "P57631": "in_stock",
  "P57632": "in_stock",
  "P57633": "in_stock",
  "P57634": "in_stock",
  "P57635": "need_purchase",
  "P57636": "in_stock",
  "P57637": "need_purchase",
  "P57638": "in_stock",
  "P57639": "need_purchase",
  "P57640": "in_stock",
  "P57641": "need_purchase",
  "P57642": "in_stock",
  "P57643": "need_purchase",
  "P57644": "need_purchase",
  "P57645": "in_stock",
  "P57646": "need_purchase",
  "P57647": "in_stock",
  "P57648": "in_stock",
  "P58701": "in_stock",
  "P58702": "in_stock",
  "P58703": "in_stock",
  "P58704": "need_purchase",
  "P58705": "need_purchase",
  "P58706": "in_stock",
  "P58707": "need_purchase",
  "P58708": "in_stock",
  "P58709": "in_stock",
  "P58710": "in_stock",
  "P58711": "in_stock",
  "P58712": "in_stock",
  "P58713": "in_stock",
  "P58714": "in_stock",
  "P58715": "in_stock",
  "P58716": "in_stock",
  "P58717": "in_stock",
  "P58718": "in_stock",
  "P58719": "in_stock",
  "P58720": "need_purchase",
  "P58721": "need_purchase",
  "P58722": "need_purchase",
  "P58723": "need_purchase",
  "P58724": "need_purchase",
  "P58725": "need_purchase",
  "P58726": "need_purchase",
  "P58727": "need_purchase",
  "P58728": "need_purchase",
  "P58729": "need_purchase",
  "P58730": "need_purchase",
  "P58731": "in_stock",
  "P58732": "in_stock",
  "P58733": "need_purchase",
  "P58734": "need_purchase",
  "P58735": "in_stock",
  "P58736": "need_purchase",
  "P58737": "need_purchase",
  "P58738": "in_stock",
  "P58739": "in_stock",
  "P58740": "in_stock",
  "P58741": "need_purchase",
  "P58742": "need_purchase",
  "P58743": "need_purchase",
  "P58744": "need_purchase",
  "P58745": "in_stock",
  "P58746": "need_purchase",
  "P58747": "need_purchase",
  "P58748": "need_purchase",
  "P58749": "need_purchase",
  "P58750": "need_purchase",
  "P58751": "need_purchase",
  "P58752": "need_purchase",
  "P58753": "in_stock",
  "P59801": "need_purchase",
  "P59802": "in_stock",
  "P59803": "need_purchase",
  "P59804": "need_purchase",
  "P59805": "need_purchase",
  "P59806": "in_stock",
  "P59807": "in_stock",
  "P59808": "need_purchase",
  "P59809": "need_purchase",
  "P59810": "need_purchase",
  "P59811": "in_stock",
  "P59812": "need_purchase",
  "P59813": "need_purchase",
  "P59814": "need_purchase",
  "P59815": "need_purchase",
  "P59816": "need_purchase",
  "P59817": "need_purchase",
  "P59818": "in_stock",
  "P59819": "in_stock",
  "P59820": "in_stock",
  "P59821": "in_stock",
  "P59822": "need_purchase",
  "P59823": "need_purchase",
  "P59824": "need_purchase",
  "P59825": "in_stock",
  "P59826": "need_purchase",
  "P59827": "need_purchase",
  "P59828": "in_stock",
  "P59829": "need_purchase",
  "P59830": "in_stock",
  "P59831": "in_stock",
  "P59832": "in_stock",
  "P59833": "need_purchase",
  "P59834": "in_stock",
  "P59835": "in_stock",
  "P59836": "in_stock",
  "P59837": "in_stock",
  "P59838": "need_purchase",
  "P59839": "need_purchase",
  "P59840": "in_stock",
  "P59841": "need_purchase",
  "P59842": "need_purchase",
  "P59843": "in_stock",
  "P59844": "in_stock",
  "P59845": "in_stock",
  "P59846": "in_stock",
  "P59847": "in_stock",
  "P59848": "in_stock",
  "P59849": "in_stock",
  "Q52131": "need_purchase",
  "Q52132": "need_purchase",
  "Q52133": "need_purchase",
  "Q52134": "need_purchase",
  "Q52135": "failed",
  "Q52136": "need_purchase",
  "Q52137": "need_purchase",
  "Q52138": "need_purchase",
  "Q52139": "in_stock",
  "R54301": "need_purchase",
  "R54302": "need_purchase",
  "R54303": "need_purchase",
  "R54304": "need_purchase",
  "R54305": "need_purchase",
  "R54306": "need_purchase",
  "R54307": "need_purchase",
  "R54308": "need_purchase",
  "R54309": "need_purchase",
  "R54310": "need_purchase",
  "R54311": "need_purchase",
  "R54312": "need_purchase",
  "R54313": "need_purchase",
  "R54316": "need_purchase",
  "S54314": "need_purchase",
  "S54315": "in_stock",
  "S62011": "in_stock",
  "S62012": "in_stock",
  "S62013": "in_stock",
  "S62014": "in_stock",
  "S62015": "in_stock",
  "S62016": "in_stock",
  "S62017": "in_stock",
  "S62018": "in_stock",
  "S62019": "in_stock",
  "S62020": "in_stock",
  "S62021": "in_stock",
  "S62022": "in_stock",
  "S62023": "in_stock",
  "S62024": "in_stock",
  "S62025": "in_stock",
  "S62026": "in_stock",
  "S62027": "in_stock",
  "S62028": "in_stock",
  "S62029": "in_stock",
  "S62030": "in_stock",
  "S62031": "in_stock",
  "S62032": "in_stock",
  "S62033": "in_stock",
  "S62034": "in_stock",
  "S62035": "in_stock",
  "S62036": "in_stock",
  "S62037": "in_stock",
  "S62038": "in_stock",
  "S62039": "in_stock",
  "S62040": "in_stock",
  "S62041": "in_stock",
  "S62042": "in_stock",
  "S62043": "in_stock",
  "S62044": "in_stock",
  "S62045": "in_stock",
  "S62046": "in_stock",
  "S62047": "in_stock",
  "S62048": "in_stock",
  "S62049": "in_stock",
  "S62050": "in_stock",
  "S62051": "in_stock",
  "S62052": "in_stock",
  "S62053": "in_stock",
  "S62054": "in_stock",
  "S62055": "in_stock",
  "S62056": "in_stock",
  "S62057": "in_stock",
  "S62058": "in_stock",
  "S62059": "in_stock",
  "S62060": "in_stock",
  "S62061": "need_purchase",
  "S62062": "need_purchase",
  "S62063": "need_purchase",
  "S62064": "need_purchase",
  "S62065": "need_purchase",
  "S62066": "need_purchase",
  "S62067": "need_purchase",
  "S62068": "need_purchase",
  "T70825001": "in_stock",
  "T70825002": "in_stock",
  "T70825003": "in_stock",
  "T70825004": "in_stock",
  "T70825005": "in_stock",
  "T70825006": "in_stock",
  "T70825007": "in_stock",
  "T70825008": "in_stock",
  "T70825009": "in_stock",
  "T70825010": "in_stock",
  "T70825011": "in_stock",
  "T70825012": "in_stock",
  "T70825013": "in_stock",
  "T70825014": "in_stock",
  "T70825015": "in_stock",
  "T70825016": "in_stock",
  "T70825017": "in_stock",
  "T70825018": "in_stock",
  "T70825019": "in_stock",
  "T70825020": "in_stock",
  "T70825021": "in_stock",
  "T70825022": "in_stock",
  "T70825023": "in_stock",
  "T70825024": "in_stock",
  "T70825025": "in_stock",
  "T70825026": "in_stock",
  "T70825027": "in_stock",
  "T70825028": "in_stock",
  "T70825029": "in_stock",
  "T70825030": "in_stock",
  "T70825031": "in_stock",
  "T70825032": "in_stock",
  "T70825033": "in_stock",
  "T70825034": "in_stock",
  "T70825035": "in_stock",
  "T70825036": "in_stock",
  "T70825037": "in_stock",
  "T70825038": "in_stock",
  "T70825039": "in_stock",
  "T70825040": "in_stock",
  "T70825041": "in_stock",
  "T70825042": "in_stock",
  "T70825043": "in_stock",
  "T70825044": "in_stock",
  "T70825045": "in_stock",
  "T70825046": "in_stock",
  "T70825047": "in_stock",
  "T70825048": "in_stock",
  "T70825049": "in_stock",
  "T70825050": "in_stock",
  "T70825051": "in_stock",
  "T70825052": "in_stock",
  "T70825101": "in_stock",
  "T70825102": "in_stock",
  "T70825103": "in_stock",
  "T70825104": "in_stock",
  "T70825105": "in_stock",
  "T70825106": "need_purchase",
  "T70825107": "need_purchase",
  "T70825108": "need_purchase",
  "T70825109": "in_stock",
  "T70825110": "in_stock",
  "T70825111": "in_stock",
  "T70825112": "in_stock",
  "T70825113": "need_purchase",
  "T70825114": "need_purchase",
  "T70825115": "need_purchase",
  "T70825116": "need_purchase",
  "T70825117": "need_purchase",
  "T70825118": "need_purchase",
  "T70825119": "need_purchase",
  "T70825120": "need_purchase",
  "T70825121": "need_purchase",
  "T70825122": "need_purchase",
  "T70825123": "need_purchase",
  "T70825124": "need_purchase",
  "T70825125": "need_purchase",
  "T70825126": "need_purchase",
  "T70825127": "need_purchase",
  "T70825128": "need_purchase",
  "T70825129": "need_purchase",
  "T70825130": "need_purchase",
  "T70825131": "need_purchase",
  "T70825132": "need_purchase",
  "T70825133": "need_purchase",
  "T70825134": "need_purchase",
  "T70825135": "need_purchase",
  "T70825136": "need_purchase",
  "T70825137": "need_purchase",
  "T70825138": "need_purchase",
  "T70825139": "need_purchase",
  "T70825140": "need_purchase",
  "T70825141": "need_purchase",
  "T70825142": "in_stock",
  "T70825143": "need_purchase",
  "T70825144": "need_purchase",
  "T70825145": "need_purchase",
  "T70825146": "need_purchase",
  "T70825147": "need_purchase",
  "T70825148": "need_purchase",
  "T70825149": "need_purchase",
  "T70825150": "in_stock",
  "T70825201": "need_purchase",
  "T70825202": "need_purchase",
  "T70825203": "need_purchase",
  "T70825204": "need_purchase",
  "T70825205": "need_purchase",
  "T70825206": "need_purchase",
  "T70825207": "need_purchase",
  "T70825208": "need_purchase",
  "T70825209": "need_purchase",
  "T70825210": "need_purchase",
  "T70825211": "in_stock",
  "T70825212": "in_stock",
  "T70825213": "in_stock",
  "T70825214": "in_stock",
  "T70825215": "need_purchase",
  "T70825216": "need_purchase",
  "T70825217": "need_purchase",
  "T70825218": "need_purchase",
  "T70825219": "need_purchase",
  "T70825220": "need_purchase",
  "T70825221": "need_purchase",
  "T70825222": "need_purchase",
  "T70825223": "need_purchase",
  "T70825224": "need_purchase",
  "T70825225": "need_purchase",
  "T70825226": "need_purchase",
  "T70825227": "need_purchase",
  "T70825228": "in_stock",
  "T70825229": "need_purchase",
  "T70825230": "need_purchase",
  "T70825231": "need_purchase",
  "T70825232": "need_purchase",
  "T70825233": "need_purchase",
  "T70825234": "need_purchase",
  "T70825235": "need_purchase",
  "T70825236": "need_purchase",
  "T70825237": "need_purchase",
  "T70825238": "need_purchase",
  "T70825239": "need_purchase",
  "T70825240": "need_purchase",
  "T70825241": "need_purchase",
  "T70825242": "need_purchase",
  "T70825243": "need_purchase",
  "T70825244": "need_purchase",
  "T70825245": "need_purchase",
  "T70825246": "need_purchase",
  "T70825247": "need_purchase",
  "T70825248": "need_purchase",
  "T70825249": "need_purchase",
  "T70825250": "need_purchase",
  "T70825251": "need_purchase",
  "T70825252": "need_purchase",
  "T70825253": "need_purchase",
  "T70825254": "need_purchase",
  "T70825255": "in_stock",
  "T70825256": "need_purchase",
  "T70825257": "need_purchase",
  "T70825258": "need_purchase",
  "T70825259": "need_purchase",
  "T70825260": "need_purchase",
  "T70825261": "need_purchase",
  "T70825262": "need_purchase",
  "T70825263": "need_purchase",
  "T70825264": "need_purchase",
  "T70825265": "need_purchase",
  "T70825266": "in_stock",
  "T70825301": "in_stock",
  "T70825302": "in_stock",
  "T70825303": "in_stock",
  "T70825304": "in_stock",
  "T70825305": "in_stock",
  "T70825306": "in_stock",
  "T70825307": "in_stock",
  "T70825308": "in_stock",
  "T70825309": "in_stock",
  "T70825310": "in_stock",
  "T70825311": "in_stock",
  "T70825312": "in_stock",
  "T70825313": "in_stock",
  "T70825314": "in_stock",
  "T70825315": "in_stock",
  "T70825316": "in_stock",
  "T70825317": "in_stock",
  "T70825318": "in_stock",
  "T70825319": "in_stock",
  "T70825321": "in_stock",
  "T70825322": "in_stock",
  "T70825323": "in_stock",
  "T70825324": "in_stock",
  "T70825325": "in_stock",
  "T70825327": "in_stock",
  "T70825328": "in_stock",
  "T70825329": "in_stock",
  "T70825330": "in_stock",
  "T70825331": "in_stock",
  "T70825332": "in_stock",
  "T70825333": "in_stock",
  "T70825334": "in_stock",
  "T70825335": "in_stock",
  "T70825336": "in_stock",
  "T70825337": "in_stock",
  "T70825338": "in_stock",
  "T70825339": "in_stock",
  "T70825340": "in_stock",
  "T70825341": "in_stock",
  "T70825342": "in_stock",
  "T70825343": "in_stock",
  "T70825345": "in_stock",
  "T70825346": "in_stock",
  "T70825347": "in_stock",
  "T70825348": "in_stock",
  "T70825349": "in_stock",
  "T70825351": "in_stock",
  "T70825352": "in_stock",
  "T70825353": "in_stock",
  "T70825354": "in_stock",
  "T70825355": "in_stock",
  "T70825356": "in_stock",
  "T70825357": "in_stock",
  "T70825358": "in_stock",
  "T70825359": "in_stock",
  "T70825360": "in_stock",
  "T70825361": "in_stock",
  "T70825362": "in_stock",
  "T70825363": "in_stock",
  "T70825364": "in_stock",
  "T70825365": "in_stock",
  "T70825366": "in_stock",
  "T70825367": "in_stock",
  "T70825368": "in_stock",
  "T70825369": "in_stock",
  "T70825370": "in_stock",
  "T70825371": "in_stock",
  "T70825372": "in_stock",
  "T70825373": "in_stock",
  "W8211": "need_purchase",
  "W8212": "need_purchase",
  "W8213": "need_purchase",
  "W8214": "need_purchase",
  "W8215": "need_purchase",
  "W8216": "need_purchase",
  "W8217": "need_purchase",
  "W8218": "need_purchase",
  "W8219": "need_purchase",
  "W8220": "need_purchase",
  "W8221": "need_purchase",
  "W8222": "need_purchase",
  "W8223": "need_purchase",
  "W8224": "need_purchase",
  "W8225": "need_purchase",
  "W8226": "need_purchase",
  "W8227": "need_purchase",
  "W8228": "need_purchase",
  "W8229": "need_purchase",
  "W8230": "need_purchase",
  "W8231": "need_purchase",
  "W8232": "need_purchase",
  "W8233": "need_purchase",
  "W8234": "need_purchase",
  "W8235": "need_purchase",
  "W8236": "need_purchase",
  "W8237": "need_purchase",
  "W8238": "need_purchase",
  "W8239": "need_purchase",
  "W8240": "need_purchase",
  "W8241": "need_purchase",
  "W8242": "need_purchase",
  "W8243": "need_purchase",
  "W8244": "need_purchase",
  "W8245": "need_purchase",
  "W8246": "need_purchase",
  "W8247": "need_purchase",
  "W8248": "need_purchase",
  "W8249": "need_purchase",
  "W8250": "need_purchase",
  "W8251": "need_purchase",
  "W8252": "need_purchase",
  "W8253": "need_purchase",
  "W8254": "need_purchase",
  "W8255": "need_purchase",
  "W8256": "need_purchase",
  "W8257": "need_purchase",
  "W8258": "in_stock",
  "W8401": "need_purchase",
  "W8402": "need_purchase",
  "W8403": "need_purchase",
  "W8404": "need_purchase",
  "W8405": "need_purchase",
  "W8406": "need_purchase",
  "W8407": "need_purchase",
  "W8408": "need_purchase",
  "W8409": "need_purchase",
  "W8410": "need_purchase",
  "W8411": "need_purchase",
  "W8412": "need_purchase",
  "W8413": "need_purchase",
  "W8414": "need_purchase",
  "W8415": "need_purchase",
  "W8416": "need_purchase",
  "W8417": "need_purchase",
  "W8418": "need_purchase",
  "W8419": "need_purchase",
  "W8420": "need_purchase",
  "W8421": "need_purchase",
  "W8422": "need_purchase",
  "W8423": "need_purchase",
  "W8424": "need_purchase",
  "W8425": "need_purchase",
  "W8426": "need_purchase",
  "W8427": "need_purchase",
  "W8428": "need_purchase",
  "W8429": "need_purchase",
  "W8430": "need_purchase",
  "W8431": "need_purchase",
  "W8432": "need_purchase",
  "W8433": "need_purchase",
  "W8434": "need_purchase",
  "W8435": "need_purchase",
  "W8436": "need_purchase",
  "W8437": "need_purchase",
  "W8438": "need_purchase",
  "W8439": "need_purchase",
  "W8440": "need_purchase",
  "W8441": "need_purchase",
  "W8442": "need_purchase",
  "W8443": "need_purchase",
  "W8444": "need_purchase",
  "W8445": "need_purchase",
  "W8446": "need_purchase",
  "W8447": "in_stock",
  "W8601": "need_purchase",
  "W8602": "need_purchase",
  "W8603": "need_purchase",
  "W8604": "need_purchase",
  "W8605": "need_purchase",
  "W8606": "need_purchase",
  "W8607": "need_purchase",
  "W8608": "need_purchase",
  "W8609": "need_purchase",
  "W8610": "need_purchase",
  "W8611": "need_purchase",
  "W8612": "need_purchase",
  "W8613": "need_purchase",
  "W8614": "need_purchase",
  "W8615": "need_purchase",
  "W8616": "need_purchase",
  "W8617": "need_purchase",
  "W8618": "need_purchase",
  "W8619": "need_purchase",
  "W8620": "need_purchase",
  "W8621": "need_purchase",
  "W8622": "need_purchase",
  "W8623": "need_purchase",
  "W8624": "need_purchase",
  "W8625": "need_purchase",
  "W8626": "need_purchase",
  "W8627": "need_purchase",
  "W8628": "need_purchase",
  "W8629": "need_purchase",
  "W8630": "need_purchase",
  "W8631": "need_purchase",
  "W8632": "need_purchase",
  "W8633": "need_purchase",
  "W8634": "need_purchase",
  "W8635": "need_purchase",
  "W8636": "need_purchase",
  "W8637": "need_purchase",
  "W8638": "need_purchase",
  "W8639": "need_purchase",
  "W8640": "need_purchase",
  "W8641": "need_purchase",
  "W8642": "need_purchase",
  "W8643": "need_purchase",
  "W8644": "need_purchase",
  "W8645": "need_purchase",
  "W8646": "need_purchase",
  "W8647": "need_purchase",
  "W8648": "need_purchase",
  "W8649": "need_purchase",
  "W8650": "need_purchase",
  "W8651": "need_purchase",
  "W8652": "need_purchase",
  "W8653": "need_purchase",
  "W8654": "need_purchase",
  "W8655": "need_purchase",
  "W8656": "need_purchase",
  "W8657": "need_purchase",
  "W8658": "need_purchase",
  "W8659": "need_purchase",
  "W8660": "in_stock",
  "W8901": "need_purchase",
  "W8902": "need_purchase",
  "W8903": "need_purchase",
  "W8904": "need_purchase",
  "W8905": "need_purchase",
  "W8906": "need_purchase",
  "W8907": "need_purchase",
  "W8908": "need_purchase",
  "W8909": "need_purchase",
  "W8910": "need_purchase",
  "W8911": "need_purchase",
  "W8912": "need_purchase",
  "W8913": "need_purchase",
  "W8914": "need_purchase",
  "W8915": "need_purchase",
  "W8916": "need_purchase",
  "W8917": "need_purchase",
  "W8918": "need_purchase",
  "W8919": "need_purchase",
  "W8920": "need_purchase",
  "W8921": "need_purchase",
  "W8922": "need_purchase",
  "W8923": "need_purchase",
  "W8924": "need_purchase",
  "W8925": "need_purchase",
  "W8926": "need_purchase",
  "W8927": "need_purchase",
  "W8928": "need_purchase",
  "W8929": "need_purchase",
  "W8930": "need_purchase",
  "W8931": "need_purchase",
  "W8932": "need_purchase",
  "W8933": "need_purchase",
  "W8934": "need_purchase",
  "W8935": "need_purchase",
  "W8936": "need_purchase",
  "W8937": "need_purchase",
  "W8938": "need_purchase",
  "W8939": "need_purchase",
  "W8940": "need_purchase",
  "W8941": "need_purchase",
  "W8942": "need_purchase",
  "W8943": "need_purchase",
  "W8944": "need_purchase",
  "W8945": "need_purchase",
  "W8946": "need_purchase",
  "W8947": "need_purchase",
  "W8948": "need_purchase",
  "W8949": "need_purchase",
  "W8950": "need_purchase",
  "W8951": "need_purchase",
  "W8952": "need_purchase",
  "W8953": "need_purchase",
  "W8954": "need_purchase",
  "W8955": "need_purchase",
  "W8956": "need_purchase",
  "W8957": "need_purchase",
  "W8958": "need_purchase",
  "W8959": "need_purchase",
  "W8960": "in_stock",
  "WL2335001": "in_stock",
  "WL2335002": "in_stock",
  "WL2335003": "in_stock",
  "WL2335004": "in_stock",
  "WL2335005": "in_stock",
  "WL2335006": "in_stock",
  "WL2335007": "in_stock",
  "WL2335008": "in_stock",
  "WL2335009": "in_stock",
  "WL2335010": "in_stock",
  "WL2335011": "in_stock",
  "WL2335012": "in_stock",
  "WL2335013": "in_stock",
  "WL2335014": "in_stock",
  "WL2335015": "in_stock",
  "WL2335016": "in_stock",
  "WL2335017": "in_stock",
  "WL2335018": "in_stock",
  "WL2335019": "in_stock",
  "WL2335020": "in_stock",
  "WL2335021": "in_stock",
  "WL2335022": "in_stock",
  "WL2335023": "in_stock",
  "WL2335024": "in_stock",
  "WL2335025": "in_stock",
  "WL2335026": "in_stock",
  "WL2335027": "in_stock",
  "WL2335028": "in_stock",
  "WL2335029": "in_stock",
  "WL2335030": "in_stock",
  "WL2335031": "in_stock",
  "WL2335032": "in_stock",
  "WL2335033": "in_stock",
  "WL2335034": "in_stock",
  "WL2335035": "in_stock",
  "WL2335036": "in_stock",
  "WL2335037": "in_stock",
  "WL2335038": "in_stock",
  "WL2335039": "in_stock",
  "WL2335040": "in_stock",
  "WL2335041": "in_stock",
  "WL2335042": "in_stock",
  "WL2335043": "in_stock",
  "WL2335044": "in_stock",
  "WL2335045": "in_stock",
  "WL2335046": "in_stock",
  "WL2335047": "in_stock",
  "WL2335048": "in_stock",
  "WL2335049": "in_stock",
  "WL2335050": "in_stock",
  "WL2335051": "in_stock",
  "WL2335052": "in_stock",
  "WL2335053": "in_stock",
  "WL2335054": "in_stock",
  "WL2335055": "in_stock",
  "WL2335056": "in_stock",
  "WL2335057": "in_stock",
  "WL2335058": "in_stock",
  "WL2335059": "in_stock",
  "WL2335060": "in_stock",
  "WL2335061": "in_stock",
  "WL2335062": "in_stock",
  "WL2335063": "in_stock",
  "WL2335064": "in_stock",
  "WL2335065": "in_stock",
  "WL2335066": "in_stock",
  "WL2335067": "in_stock",
  "WL2335068": "in_stock",
  "WL2335069": "in_stock",
  "WL2335070": "in_stock",
  "WL2335071": "in_stock",
  "WL2335072": "in_stock",
  "WL2335073": "in_stock",
  "WL2335074": "in_stock",
  "WL2335075": "in_stock",
  "WL2335076": "in_stock",
  "WL2335077": "in_stock",
  "WL2335078": "in_stock",
  "WL2335079": "in_stock",
  "WL2335080": "in_stock",
  "WL2335081": "in_stock",
  "WL2335082": "in_stock",
  "WL2335083": "in_stock",
  "WL2335084": "in_stock",
  "WL2335085": "in_stock",
  "WL2335086": "in_stock",
  "WL2335087": "in_stock",
  "WL2335088": "in_stock",
  "WL2335089": "in_stock",
  "WL2335090": "in_stock",
  "WL2335091": "in_stock",
  "WL2335092": "in_stock",
  "WL2335093": "in_stock",
  "WL2335094": "in_stock",
  "WL2335095": "in_stock",
  "WL2335096": "in_stock",
  "WL2335097": "in_stock",
  "WL2335098": "in_stock",
  "WL2335099": "in_stock",
  "WL2335100": "in_stock",
  "WL2335101": "in_stock",
  "WL2335102": "in_stock",
  "WL2335103": "in_stock",
  "WL2335104": "in_stock",
  "WL2335105": "in_stock",
  "WL2335106": "in_stock",
  "WL2335107": "in_stock",
  "WL2335108": "in_stock",
  "WL2335109": "in_stock",
  "WL2335110": "in_stock",
  "WL2335111": "in_stock",
  "WL2335112": "in_stock",
  "WL2335113": "in_stock",
  "WL2335114": "in_stock",
  "WL2335115": "in_stock",
  "WL2335116": "in_stock",
  "WL2335117": "in_stock",
  "WL2335118": "in_stock",
  "WL2335119": "in_stock",
  "WL2335120": "in_stock",
  "WL2335121": "in_stock",
  "WL2335122": "in_stock",
  "WL2335123": "in_stock",
  "WL2335124": "in_stock",
  "WL2335125": "in_stock",
  "WL2335126": "in_stock",
  "WL2335127": "in_stock",
  "WL2335128": "in_stock",
  "WL2335129": "in_stock",
  "WL2335130": "in_stock",
  "WL2335131": "in_stock",
  "WL2335132": "in_stock",
  "WL2335133": "in_stock",
  "WL2335134": "in_stock",
  "WL2335135": "in_stock",
  "WL2335136": "in_stock",
  "WL2335137": "in_stock",
  "WL2335138": "in_stock",
  "WL2335139": "in_stock",
  "WL2335140": "in_stock",
  // YUBOYUAN Collection
  "YB18844": "need_purchase",
  "YB18845": "need_purchase",
  "YB18847": "need_purchase",
  "YB18846": "need_purchase",
  "YB18848": "need_purchase",
  "YB18266": "need_purchase",
  "YB18267": "need_purchase",
  "YB18327": "need_purchase",
  "YB18268": "need_purchase",
  "YB18860": "need_purchase",
  "YB18859": "need_purchase",
  "YB18861": "need_purchase",
  "YB18505": "need_purchase",
  "YB18513": "need_purchase",
  "YB18506": "need_purchase",
  "YB18759": "need_purchase",
  "YB18760": "need_purchase",
  "YB18747": "need_purchase",
  "YB18749": "need_purchase",
  "YB18706": "need_purchase",
  "YB18707": "need_purchase",
  "YB18322": "need_purchase",
  "YB18731": "need_purchase",
  "YB18257": "need_purchase",
  "YB18211": "need_purchase",
  "YB18734": "need_purchase",
  "YB18243": "need_purchase",
  "YB18244": "need_purchase",
  "YB18723": "need_purchase",
  "YB18817": "need_purchase",
  "YB18701": "need_purchase",
  "YB18702": "need_purchase",
  "YB18245": "need_purchase",
  "YB18242": "need_purchase",
  "YB18247": "need_purchase",
  "YB18252": "need_purchase",
  "YB18801": "need_purchase",
  "YB18323": "need_purchase",
  "YB18324": "need_purchase",
  "YB18768": "need_purchase",
  "YB18212": "need_purchase",
  "YB18214": "need_purchase",
  "YB18331": "need_purchase",
  "YB18213": "need_purchase",
  "YB18200": "need_purchase",
  "YB18824": "need_purchase",
  "YB18745": "need_purchase",
  "YB18746": "need_purchase",
  "YB18215": "need_purchase",
  "YB18849": "need_purchase",
  "YB18780": "need_purchase",
  "YB18779": "need_purchase",
  "YB18778": "need_purchase",
  "YB18777": "need_purchase",
  "YB18246": "need_purchase",
  "YB18300": "need_purchase",
  "YB18202": "need_purchase",
  "YB18823": "need_purchase",
  "YB18217": "need_purchase",
  "YB18733": "need_purchase",
  "YB18840": "need_purchase",
  "YB18841": "need_purchase",
  "YB18839": "need_purchase",
  "YB18842": "need_purchase",
  "YB18843": "need_purchase",
  "YB18752": "need_purchase",
  "YB18753": "need_purchase",
  "YB18761": "need_purchase",
  "YB18866": "need_purchase",
  "YB18204": "need_purchase",
  "YB18203": "need_purchase",
  "YB18775": "need_purchase",
  "YB18774": "need_purchase",
  "YB18773": "need_purchase",
  "YB18722": "need_purchase",
  "YB18864": "need_purchase",
  "YB18776": "need_purchase",
  "YB18800": "need_purchase",
  "YB18805": "need_purchase",
  "YB18816": "need_purchase",
  "YB18808": "need_purchase",
  "YB18807": "need_purchase",
  "YB18806": "need_purchase",
  "YB18813": "need_purchase",
  "YB18815": "need_purchase",
  "YB18814": "need_purchase",
  "YB18809": "need_purchase",
  "YB18822": "need_purchase",
  "YB18826": "need_purchase",
  "YB18260": "need_purchase",
  "YB18825": "need_purchase",
  "YB18205": "need_purchase",
  "YB18514": "need_purchase",
  "YB18511": "need_purchase",
  "YB18521": "need_purchase",
  "YB18804": "need_purchase",
  "YB18803": "need_purchase",
  "YB18802": "need_purchase",
  "YB18520": "need_purchase",
  "YB18312": "need_purchase",
  "YB18516": "need_purchase",
  "YB18239": "need_purchase",
  "YB18741": "need_purchase",
  "YB18249": "need_purchase",
  "YB18241": "need_purchase",
  "YB18250": "need_purchase",
  "YB18865": "need_purchase",
  "YB18787": "need_purchase",
  "YB18788": "need_purchase",
  "YB18812": "need_purchase",
  "YB18789": "need_purchase",
  "YB18758": "need_purchase",
  "YB18790": "need_purchase",
  "YB18786": "need_purchase",
  "YB18785": "need_purchase",
  "YB18784": "need_purchase",
  "YB18792": "need_purchase",
  "YB18791": "need_purchase",
  "YB18756": "need_purchase",
  "YB18781": "need_purchase",
  "YB18782": "need_purchase",
  "YB18783": "need_purchase",
  "YB18811": "need_purchase",
  "YB18810": "need_purchase",
  "YB18855": "need_purchase",
  "YB18856": "need_purchase",
  "YB18853": "need_purchase",
  "YB18852": "need_purchase",
  "YB18850": "need_purchase",
  "YB18851": "need_purchase",
  "YB18854": "need_purchase",
  "YB18857": "need_purchase",
  "YB18858": "need_purchase",
  "YB18827": "need_purchase",
  "YB18828": "need_purchase",
  "YB18829": "need_purchase",
  "YB18830": "need_purchase",
  "YB18831": "need_purchase",
  "YB18832": "need_purchase",
  "YB18862": "need_purchase",
  "YB18863": "need_purchase",
  "YB18528": "need_purchase",
  "YB18532": "need_purchase",
  "YB18714": "need_purchase",
  "YB18715": "need_purchase",
  "YB18537": "need_purchase",
  "YB18538": "need_purchase",
  "YB18838": "need_purchase",
  "YB18836": "need_purchase",
  "YB18837": "need_purchase",
  "YB18834": "need_purchase",
  "YB18835": "need_purchase",
  "YB18833": "need_purchase",
  "YB18518": "need_purchase",
  "YB18519": "need_purchase",
  "YB18793": "need_purchase",
  "YB18818": "need_purchase",
  "YB18819": "need_purchase",
  "YB18820": "need_purchase",
  "YB18821": "need_purchase",
  "YB18794": "need_purchase",
  "YB18795": "need_purchase",
  "YB18796": "need_purchase",
  "YB18798": "need_purchase",
  "YB18799": "need_purchase",
  "YB18797": "need_purchase",
  "YB18549": "need_purchase",
  "YB18550": "need_purchase",
  // YUBOYUAN Colorful Collection
  "YB70150": "need_purchase",
  "YB70152": "need_purchase",
  "YB70118": "need_purchase",
  "YB70122": "need_purchase",
  "YB70146": "need_purchase",
  "YB70144": "need_purchase",
  "YB70142": "need_purchase",
  "YB70139": "need_purchase",
  "YB70149": "need_purchase",
  "YB70135": "need_purchase",
  "YB70108": "need_purchase",
  "YB70116": "need_purchase",
  "YB70134": "need_purchase",
  "YB70101": "need_purchase",
  "YB70114": "need_purchase",
  "YB70112": "need_purchase",
  "YB70140": "need_purchase",
  "YB70156": "need_purchase",
  "YB70111": "need_purchase",
  "YB70115": "need_purchase",
  "YB70147": "need_purchase",
  "YB70133": "need_purchase",
  "YB70104": "need_purchase",
  "YB70110": "need_purchase",
  "YB70123": "need_purchase",
  "YB70109": "need_purchase",
  "YB70113": "need_purchase",
  "YB70126": "need_purchase",
  "YB70124": "need_purchase",
  "YB70151": "need_purchase",
  "YB70121": "need_purchase",
  "YB70125": "need_purchase",
  "YB70137": "need_purchase",
  "YB70136": "need_purchase",
  "YB70143": "need_purchase",
  "YB70132": "need_purchase",
  "YB70128": "need_purchase",
  "YB70129": "need_purchase",
  "YB70145": "need_purchase",
  "YB70130": "need_purchase",
  "YB70102": "need_purchase",
  "YB70141": "need_purchase",
  "YB70127": "need_purchase",
  "YB70119": "need_purchase",
  "YB70154": "need_purchase",
  "YB70131": "need_purchase",
  "YB70105": "need_purchase",
  "YB70138": "need_purchase",
  "YB70117": "need_purchase",
  "YB70148": "need_purchase",
  "YB70155": "need_purchase",
  "YB70103": "need_purchase",
  "YB70120": "need_purchase",
  "YB70153": "need_purchase",
  "YB70106": "need_purchase",
  "YB70107": "need_purchase",
};

// Helper function to get inventory status
export const getInventoryStatus = (fabricCode) => {
  if (!fabricCode) return null;
  const status = MX_INVENTORY[fabricCode];
  if (status) return status;
  // Try without trailing characters
  const cleanCode = fabricCode.replace(/\s+/g, '').trim();
  return MX_INVENTORY[cleanCode] || null;
};

// Get counts for dashboard/stats
export const getInventoryCounts = () => {
  const counts = { in_stock: 0, need_purchase: 0, failed: 0, total: 0 };
  Object.values(MX_INVENTORY).forEach(status => {
    counts[status]++;
    counts.total++;
  });
  return counts;
};
